var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFilterClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "85203378-531F-4A93-A4F7-B1753789AAFA") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PLP",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01-PLP",
    transform: "translate(-256.000000, -450.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F5F5F5",
    x: 0,
    y: 160,
    width: 1920,
    height: 3408
  }), /*#__PURE__*/React.createElement("g", {
    id: "Filters",
    transform: "translate(176.000000, 416.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI/Content/Filter",
    transform: "translate(0.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#38291E",
    x: 0,
    y: 0,
    width: 106,
    height: 24,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon/Close",
    transform: "translate(80.000000, 2.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9564564,4.04354372 C16.1348208,4.22190818 16.1393943,4.50825253 15.9701767,4.69215442 L15.9564564,4.70645633 L10.66325,10.00025 L15.9564564,15.2935438 C16.1395146,15.476602 16.1395146,15.7733981 15.9564564,15.9564564 C15.7780919,16.1348208 15.4917476,16.1393943 15.3078457,15.9701767 L15.2935438,15.9564564 L10.00025,10.66325 L4.70645633,15.9564564 C4.52339806,16.1395146 4.22660198,16.1395146 4.04354372,15.9564564 C3.86517926,15.7780919 3.86060581,15.4917476 4.02982337,15.3078457 L9.33725002,10.00025 L4.04354372,4.70645633 C3.86048545,4.52339806 3.86048545,4.22660198 4.04354372,4.04354372 C4.22190818,3.86517926 4.50825253,3.86060581 4.69215442,4.02982337 L4.70645633,4.04354372 L10.00025,9.33725002 L15.2935438,4.04354372 C15.476602,3.86048545 15.7733981,3.86048545 15.9564564,4.04354372 Z",
    id: "Combined-Shape"
  }))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterClose);
export default __webpack_public_path__ + "static/media/filter-close.c8fe2725.svg";
export { ForwardRef as ReactComponent };